// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"665c3aee","248":"7810b872","316":"0b57e7e3","337":"0ad62c67","445":"31dd44ef","526":"5bdbafd3","642":"74e68db0","652":"2ef60f53","751":"e6b67bbe"}[chunkId] + ".chunk.js";
};